import React, { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Layout } from "antd";
import Sidebar from "../Components/SideBarMenu/SidebarMenu";
import AppHeader from "../Components/AppHeader/AppHeader";
import PrivateRoute from "../Components/PrivateRoute";
import PageNotFound from "../Pages/PageNotFound";
import ManageAdmins from "../Pages/Users/Admins/ManageAdmins";
import ManageStudent from "../Pages/Users/Students/ManageStudent";
import Instructors from "../Pages/Users/Instructors/Instructors";
const AddCustomPage = React.lazy(() => import("../Pages/AddCustomPage"))
const ZoomSettings = React.lazy(() => import("../Pages/ZoomSettings"));
const CustomPage = React.lazy(() => import("../Pages/CustomPage"));
const Addonheader = React.lazy(() => import("../Components/Addonheader"));
const Dashboard = lazy(() => import("../Pages/Dashboard"));

const DirectorDashboard = React.lazy(() =>
  import("../Pages/directorDashboard/DirectorDashboard")
);

const SkillDevelopment = React.lazy(() =>
  import("../Pages/skillDevelopment/SkillDevelopment")
);

const EmployeeExchange = React.lazy(() =>
  import("../Pages/employeeExchange/EmployeeExchange")
);

const Course = React.lazy(() => import("../Pages/Courses"));
const AddNewCourse = React.lazy(() => import("../Pages/addCourses"));
const Categories = React.lazy(() => import("../Pages/Categories"));
const Coupons = React.lazy(() => import("../Pages/Coupons"));
const AddNewCategory = React.lazy(() => import("../Pages/AddNewCategory"));
const AddNewCoupon = React.lazy(() =>
  import("../Pages/newCoupon/AddNewCoupon")
);
const Contact = React.lazy(() => import("../Pages/Contact"));


const AddBlog = React.lazy(() => import("../Pages/AddBlog"));
const AllBlogs = React.lazy(() => import("../Pages/AllBlogs"));
const PendingBlogs = React.lazy(() => import("../Pages/PendingBlogs"));
const BlogsCategories = React.lazy(() => import("../Pages/BlogsCategories"));
const BlogsSettings = React.lazy(() => import("../Pages/BlogsSettings"));


const CourseEnrollment = React.lazy(() => import("../Pages/CourseEnrollment"));

const EnrollHistory = React.lazy(() => import("../Pages/Enroll_history"));

const { Content } = Layout;

const AuthenticatedRoutes = () => {
  const location = useLocation();
  const isDashboard = location.pathname === "/";
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ display: "flex" }}>
        {location.pathname !== "/" && <Sidebar collapsed={collapsed} />}
        <Layout style={{ flex: 1 }}>
          <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} />
          <Content
            style={{
              padding: "0 50px",
              marginTop: 0,
              minHeight: 280,
            }}
          >
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                {isDashboard ? (
                  <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                ) : (
                  <>
                    <Route
                      path="/director-dashboard"
                      element={
                        <PrivateRoute>
                          <DirectorDashboard />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/skill-development"
                      element={
                        <PrivateRoute>
                          <SkillDevelopment />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/employee-exchange"
                      element={
                        <PrivateRoute>
                          <EmployeeExchange />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/manage-course"
                      element={
                        <PrivateRoute>
                          <Course />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/add-new-course"
                      element={
                        <PrivateRoute>
                          <AddNewCourse />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/coupons"
                      element={
                        <PrivateRoute>
                          <Coupons />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/course-categories"
                      element={
                        <PrivateRoute>
                          <Categories />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/category_form/add_category"
                      element={
                        <PrivateRoute>
                          <AddNewCategory />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/coupon_form/add_coupon_form"
                      element={
                        <PrivateRoute>
                          <AddNewCoupon />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/contact"
                      element={
                        <PrivateRoute>
                          <Contact />
                        </PrivateRoute>
                      }
                    />

                    <Route
                      path="/blog/all-blogs"
                      element={
                        <PrivateRoute>
                          <AllBlogs />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blogs/pending-blogs"
                      element={
                        <PrivateRoute>
                          <PendingBlogs />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blog/category"
                      element={
                        <PrivateRoute>
                          <BlogsCategories />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blog/settings"
                      element={
                        <PrivateRoute>
                          <BlogsSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blog/add"
                      element={
                        <PrivateRoute>
                          <AddBlog />
                        </PrivateRoute>
                      }
                    />

                    <Route
                      path="/users/admin-users"
                      element={
                        <PrivateRoute>
                          <ManageAdmins />
                        </PrivateRoute>
                      }
                    />

                    <Route
                      path="/users/admin-instructors"
                      element={
                        <PrivateRoute>
                          <Instructors />
                        </PrivateRoute>
                      }
                    />

                    <Route
                      path="/users/admin-students"
                      element={
                        <PrivateRoute>
                          <ManageStudent />
                        </PrivateRoute>
                      }
                    />
                        
                    <Route path="/director-dashboard" element={<PrivateRoute><DirectorDashboard /></PrivateRoute>} />
                    <Route path="/skill-development" element={<PrivateRoute><SkillDevelopment /></PrivateRoute>} />
                    <Route path="/employee-exchange" element={<PrivateRoute><EmployeeExchange /></PrivateRoute>} />
                    <Route path="/courses/manage-course" element={<PrivateRoute><Course /></PrivateRoute>} />
                    <Route path="/courses/add-new-course" element={<PrivateRoute><AddNewCourse /></PrivateRoute>} />
                    <Route path="/courses/coupons" element={<PrivateRoute><Coupons /></PrivateRoute>} />
                    <Route path="/courses/course-categories" element={<PrivateRoute><Categories /></PrivateRoute>} />
                    <Route path="/category_form/add_category" element={<PrivateRoute><AddNewCategory /></PrivateRoute>} />
                    <Route path="/coupon_form/add_coupon_form" element={<PrivateRoute><AddNewCoupon /></PrivateRoute>} />
                    <Route path="/contact" element={<PrivateRoute>< Contact /></PrivateRoute>} />
                    <Route path="/addons/all-addons" element={<PrivateRoute>< Addonheader/></PrivateRoute>} />
                    <Route path="/settings/zoom-settings" element={<PrivateRoute>< ZoomSettings/></PrivateRoute>} />
                    <Route path="/settings/custom-page" element={<PrivateRoute>< CustomPage/></PrivateRoute>} />
                    <Route path="/settings/add-custom-page" element={<PrivateRoute>< AddCustomPage/></PrivateRoute>} />
                    <Route path="/coupon_form/add_coupon_form" element={<PrivateRoute><AddNewCoupon /></PrivateRoute>} />
                    <Route path="/contact" element={<PrivateRoute>< Contact /></PrivateRoute>} />


                    <Route path="/enrollments/course" element={<CourseEnrollment />} />


                    <Route path="/enrollments/enroll-history" element={<EnrollHistory />} />



                    <Route path="/blog/all-blogs" element={<PrivateRoute>< AllBlogs /></PrivateRoute>} />
                    <Route path="/blogs/pending-blogs" element={<PrivateRoute>< PendingBlogs /></PrivateRoute>} />
                    <Route path="/blog/category" element={<PrivateRoute>< BlogsCategories /></PrivateRoute>} />
                    <Route path="/blog/settings" element={<PrivateRoute>< BlogsSettings /></PrivateRoute>} />
                    <Route path="/blog/add" element={<PrivateRoute>< AddBlog /></PrivateRoute>} />


                    {/* settings section routes */}

                    <Route path="/custom-page" element={<PrivateRoute>< CustomPage /></PrivateRoute>} />

                    <Route path="*" element={<PageNotFound />} />
                  </>
                )}
              </Routes>
            </Suspense>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AuthenticatedRoutes;
